import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
// import Heading from '../../Heading';

class StartPage extends React.PureComponent {
  componentDidMount() {

  }

  render() {
    return (
      <fieldset className="justifycentre page-1 images-container">
        <Paragraph classes="images extraMargin" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/getactive-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/loseweight-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/drink-less.png" alt="" width="100" height="100" />
        </Paragraph>
        <Paragraph classes="width-limited" center>Are you still making positive changes to your lifestyle?</Paragraph>
        <Paragraph classes="width-limited" center>
          We are keen to hear how things have been going for you. The answers you give will help us to understand any changes you have made to your lifestyle and see if you would benefit from further support.
        </Paragraph>
        <Paragraph classes="width-limited" center>
          Your feedback is valuable. It will help us make sure we offer the best support possible to you and others. Please answer the questions as accurately and honestly as you can.
        </Paragraph>
        <Paragraph classes="button-groups" center>
          <Button classes={['color-button']} label="Start" onClick={this.props.onSubmit} />
        </Paragraph>
      </fieldset>
    );
  }
}

StartPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'assessment', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(StartPage);



// WEBPACK FOOTER //
// ./src/Components/Assessment/Pages/StartPage.jsx